import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { UpModule } from './upmodule';
import Result from '../../_interface/result';
var devModeState = false;
export var UpLog = function (_UpModule) {
    _inherits(UpLog, _UpModule);

    function UpLog() {
        _classCallCheck(this, UpLog);

        return _possibleConstructorReturn(this, (UpLog.__proto__ || Object.getPrototypeOf(UpLog)).apply(this, arguments));
    }

    _createClass(UpLog, [{
        key: 'enableConsoleLog',
        value: function enableConsoleLog(params) {
            return this.generatePromiseByPluginFunctionWithNotPrint('enableConsoleLog', params);
        }
    }, {
        key: 'printLog',
        value: function printLog(params) {
            if (devModeState) {
                return this.generatePromiseByPluginFunctionWithNotPrint('printLog', params);
            }
            return new Promise(function (resolve, _reject) {
                resolve(new Result('000000', '\u8C03\u7528\u65B9\u6CD5 printLog \u5931\u8D25\uFF0C\u8C03\u8BD5\u6A21\u5F0F\u672A\u5F00\u542F'));
            });
        }
        // 输出uplusapi日志

    }, {
        key: 'printUplusApiLog',
        value: function printUplusApiLog(params) {
            var _this2 = this;

            if (devModeState === false) {
                return new Promise(function (resolve, _reject) {
                    resolve(new Result('000000', '\u8C03\u7528\u65B9\u6CD5 printUplusApiLog \u5931\u8D25\uFF0C\u8C03\u8BD5\u6A21\u5F0F\u672A\u5F00\u542F'));
                });
            }
            return new Promise(function (resolve, _reject) {
                _this2.plugin.printLog(params, function (result) {
                    if (result.isSuccessful()) {
                        resolve(new Result('000000', '\u8C03\u7528\u65B9\u6CD5 printUplusApiLog \u6210\u529F', result.retData));
                    } else {
                        resolve(new Result('000000', '\u8C03\u7528\u65B9\u6CD5 printUplusApiLog \u5931\u8D25\uFF0C\u8C03\u8BD5\u6A21\u5F0F\u672A\u5F00\u542F', result.retData));
                    }
                });
            });
        }
        // 打印参数

    }, {
        key: 'printParameters',
        value: function printParameters(funcName, params) {
            var paramsStr = '';
            try {
                if (params) {
                    paramsStr = JSON.stringify(params);
                }
            } catch (e) {}
            return this.printUplusApiLog({ level: 'debug', tag: 'uplusapi', msg: funcName + ':' + paramsStr });
        }
        // 打印成功结果

    }, {
        key: 'printSucceedResult',
        value: function printSucceedResult(funcName, result) {
            var dataStr = '';
            try {
                if (result.retData) {
                    dataStr = JSON.stringify(result.retData);
                }
            } catch (e) {}
            return this.printUplusApiLog({
                level: 'debug',
                tag: 'uplusapi',
                msg: 'retCode = 000000, msg = ' + funcName + ' success,data = ' + dataStr
            });
        }
        // 打印失败结果

    }, {
        key: 'printFailResult',
        value: function printFailResult(funcName, result) {
            var msg = funcName + ' fail';
            var dataStr = '';
            try {
                if (result.retData) {
                    dataStr = JSON.stringify(result.retData);
                }
            } catch (e) {}
            if (result.retData) {
                msg = msg + ',data = ' + dataStr;
            }
            return this.printUplusApiLog({
                level: 'debug',
                tag: 'uplusapi',
                msg: 'retCode = ' + result.retCode + ', msg = ' + msg
            });
        }
    }], [{
        key: 'getDevModeState',
        value: function getDevModeState(module) {
            module.getStringValue({
                storageName: 'debug/dev_mode_state',
                storageValue: 'OFF'
            }).then(function (retData) {
                devModeState = retData.retData === 'ON';
            }, function () {});
        }
    }]);

    return UpLog;
}(UpModule);